export default {
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'fr',
}
